import {
  decodeOrElseNull,
  timeOfDayFromStringCodec,
  uuidStringCodec,
} from "../codecs";

export const parseUUID = decodeOrElseNull(uuidStringCodec);
export const parseTimeOfDay = decodeOrElseNull(timeOfDayFromStringCodec);
